import { render, staticRenderFns } from "./by-tag.vue?vue&type=template&id=161c9afc"
import script from "./by-tag.vue?vue&type=script&lang=js"
export * from "./by-tag.vue?vue&type=script&lang=js"
import style0 from "./by-tag.vue?vue&type=style&index=0&id=161c9afc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports